module.exports = __webpack_public_path__ + "static/media/wizualizacja-67.058b619a.png";